import React, { useState, useEffect, useRef } from 'react';
import { Device } from '@twilio/voice-sdk';
import { useAuth } from '../context/AuthContext';
import Pusher from 'pusher-js';
// Use environment variable for API base URL
const CALLAPP_TOKEN_URL = process.env.REACT_APP_API_BASE_URL + '/twilio/token';
const CALLAPP_VOICE_URL = process.env.REACT_APP_API_BASE_URL + '/twilio/voice';

const CallPage = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [device, setDevice] = useState(null);
  const [status, setStatus] = useState('');
  const deviceRef = useRef(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    const initializeDevice = async () => {
      setStatus('Initializing Twilio device...');
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/twilio/token`);
        if (!response.ok) {
          throw new Error(`Failed to fetch token: ${response.statusText}`);
        }
        const data = await response.json();
        const device = new Device(data.token, { debug: true });
        deviceRef.current = device;

        device.on('ready', () => setStatus('Device ready to make calls'));
        device.on('error', (error) => setStatus(`Device error: ${error.message}`));
        device.on('connect', () => setStatus('Call connected'));
        device.on('disconnect', () => setStatus('Call disconnected'));
      } catch (error) {
        setStatus(`Error initializing device: ${error.message}`);
      }
    };

    initializeDevice();

    return () => {
      if (deviceRef.current) {
        deviceRef.current.destroy();
      }
    };
  }, []);

  useEffect(() => {
    if (!currentUser || !currentUser.id) return;
    // Initialize Pusher using environment variables
    const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      cluster: process.env.REACT_APP_PUSHER_CLUSTER,
      authEndpoint: process.env.REACT_APP_API_BASE_URL + '/pusher/auth', // if using private channels
    });
    const channel = pusher.subscribe(`private-user-${currentUser.id}`);
    channel.bind('call-event', (data) => {
      if (data && data.status) {
        setStatus('Call status: ' + data.status);
        console.log('[DEBUG] Realtime call event:', data);
      }
    });
    return () => {
      channel.unbind_all();
      channel.unsubscribe();
      pusher.disconnect();
    };
  }, [currentUser]);

  const handleInputChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleCall = () => {
    if (!deviceRef.current) {
      setStatus('Device not ready');
      console.log('[DEBUG] Device not ready');
      return;
    }

    const trimmedPhoneNumber = phoneNumber.trim();
    if (!trimmedPhoneNumber) {
      setStatus('Please enter a valid phone number');
      console.log('[DEBUG] No valid destination number provided');
      return;
    }

    setStatus(`Calling ${trimmedPhoneNumber}...`);
    const formattedPhoneNumber = trimmedPhoneNumber.startsWith('+') ? trimmedPhoneNumber : `+${trimmedPhoneNumber}`;
    console.log('[DEBUG] Formatted number:', formattedPhoneNumber);

    const payload = { To: formattedPhoneNumber };
    console.log('[DEBUG] Payload sent to Device.connect():', payload);

    deviceRef.current.connect(payload);
  };

  const handleHangup = () => {
    if (deviceRef.current) {
      deviceRef.current.disconnectAll();
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '50px auto', padding: 20, border: '1px solid #ccc', borderRadius: 8 }}>
      <h2>ဖုန်းခေါ်ရန်</h2>
      <input
        type="tel"
        placeholder="ဖုန်းနံပါတ်ရိုက်ပါ"
        value={phoneNumber}
        onChange={handleInputChange}
        style={{ width: '100%', padding: 8, fontSize: 16, marginBottom: 12 }}
      />
      <button onClick={handleCall} style={{ width: '100%', padding: 10, fontSize: 16, marginBottom: 8 }}>
        ဖုန်းခေါ်မည်
      </button>
      <button onClick={handleHangup} style={{ width: '100%', padding: 10, fontSize: 16, background: '#f44336', color: '#fff' }}>
        ချန်မည်
      </button>
      <div style={{ marginTop: 16, color: '#555' }}>{status}</div>
    </div>
  );
};

export default CallPage;